const truncateStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 2px'
  };
  
  export const tableColumns = [
    {
      name: 'QA ID',
      selector: row => row.qa_id,
      sortable: true,
      center: true,
      width: '150px',
      style: truncateStyle,
    },
    {
      name: 'Question',
      selector: row => row.qa_details,
      sortable: true,
      center: true,
      width: '240px',
      style: truncateStyle,
      cell: row => (
        <div style={{ 
          ...truncateStyle,
          color: '#5C61F2', 
          fontWeight: 'bold',
          width: '100%',
          textAlign: 'center'
        }}>
          {row.qa_details}
        </div>
      ),
    },
    {
      name: 'Author',
      selector: row => row.author,
      sortable: true,
      center: true,
      width: '150px',
      style: truncateStyle,
    },
    {
      name: 'Submitted Date',
      selector: row => row.submittedDate,
      sortable: true,
      center: true,
      width: '150px',
      style: truncateStyle,
    },
    {
      name: 'Updated by',
      selector: row => row.updatedBy,
      sortable: true,
      center: true,
      width: '150px',
      style: truncateStyle,
    },
    {
      name: 'Updated On',
      selector: row => row.updatedOn,
      sortable: true,
      center: true,
      width: '150px',
      style: truncateStyle,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      center: true,
      width: '100px',
      id: 'status',
      style: truncateStyle,
    },
    {
      name: 'Action',
      selector: row => row.action,
      sortable: false,
      center: true,
      width: '160px',
      id: 'action',
      style: truncateStyle,
    },
  ];